import React from "react";

export const SocialAnchor = ({ href, children }) => {
  return (
    <a style={{ textDecoration: "none" }} href={href}>
      {children}
    </a>
  );
};
